import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import CustomDatePicker from '../../../../Components/Utility/DatePicker/DatePicker';

export function DatePickerElement({ label, onChange, path, value, disable, requiredField, error, placeholder }) {
  return (
    <>
      <label className="asterisk-req ">
        {label}
        {requiredField && <span>*</span>}
      </label>
      <CustomDatePicker
        valueProp={value}
        dateFormat="dd-MMM-yyyy"
        popperPlace="top-end"
        disable={disable}
        placeholder={placeholder}
        autoComplete="off"
        name="selectedDate"
        onChange={(date) => onChange(date, path)}
      />
      {error?.status && <span className="error-message">{error.errorMsg}</span>}
    </>
  );
}
export default DatePickerElement;
